<template>
  <div>
    <Label class="text-sm font-medium">{{ type === 'youtube' ? 'Video Fit' : 'Image Fit' }}</Label>
    <div class="mt-3">
      <Select :model-value="objectFit || 'cover'" @update:model-value="$emit('update', String($event))">
        <SelectTrigger>
          <SelectValue placeholder="Select fit mode" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="cover">Cover (crop to fill)</SelectItem>
          <SelectItem value="contain">Contain (fit within bounds)</SelectItem>
          <SelectItem v-if="type === 'image'" value="fixed-aspect">Fixed Aspect Ratio</SelectItem>
        </SelectContent>
      </Select>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface Props {
  objectFit?: string
  type: 'image' | 'youtube'
}

defineProps<Props>()

defineEmits<{
  update: [value: string]
}>()
</script>
